<div class="back-holder"></div>
<div class="wrap">
  <div class="content" [style]="'max-width:'+vars.logoWidth">
    <div class="left-section">
      <div class="logo">
        <div class="link" (click)="goToHome()">
          <img class="brand-logo" ngSrc="{{vars.domain_details.logoLightBg}}" width="175" height="72" [alt]="vars.domain_details.name" priority />
          <!-- <span>Founded in USA</span> -->
        </div>
      </div>
    </div>
    <div class="right-section">
      @if (vars.pageLayoutConfig?.showSecure) {
        <div class="secure"><img ngSrc="assets/images/lock.png" width="32" height="32" alt="secure"><span>100% secure</span></div>
      }
      @if (vars.pageLayoutConfig?.showCurrency) {
        <div class="currency-drop">
          <app-currency-dropdown [selectedCurrency]="vars.currency" (onCurrencyChange)="setCurrency($event)" />
        </div>
      }
      @if (vars.pageLayoutConfig?.showProfile && !vars.isPermanentLoggedIn) {
        <button class="signin-btn" (click)="openLogin(loginForm)" appRipple>Sign in</button>
      }
      @if (vars.pageLayoutConfig?.showProfile && vars.isPermanentLoggedIn) {
        <div class="profile-section">
          <div class="img-wrapper" appRipple (click)="onProfileSidebarOpen()">
            @if (userData?.avtar?.cdn_path) {
              <img [src]="userData?.avtar?.cdn_path" alt="user img" />
            }
            @if (!userData?.avtar?.cdn_path) {
              <mat-icon>person</mat-icon>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>

<app-side-nav />

<ng-template #loginForm>
  @if (!vars.isPermanentLoggedIn) {
    <app-component-loader selector="app-signin-signup" [inputs]="{showClose: true}" />
  }
</ng-template>
